export const ErrorCode = {
    SearchPostCode: 1,
    CheckExistsAndCreateInitialPolicy: 2,
    AddDeviceDetection: 3,
    SetTradeForDeviceDetection: 4,
    SetPremiumForDeviceDetection: 5,
    SendQuoteEmail: 6,
    GetQuestionSet: 7,
    SubmitAnswers: 8,
    RetrieveDetailsForQuote: 9,
    Purchase: 10,
    RealexCompleted: 11,
    ConvertPolicyMonthly: 12,
    ConvertPolicyAnnually: 13
}